import axios from 'axios'
import {API_URL} from 'app/utils/common/constants'
import {ResponseArray} from 'setup/axios/HttpResponse'
import {DistrictApiDto} from '../models/District'

const districtApi = {
  getDistrictsByProvince(provinceId: string): Promise<ResponseArray<DistrictApiDto>> {
    const encodedProvince = encodeURIComponent(provinceId)
    const url = `${API_URL}/api/v1/district/provine/${encodedProvince}`
    return axios.get(url)
  },
  getDistrictsByProvinceCodes(provinceCodes: string[]): Promise<ResponseArray<DistrictApiDto>> {
    const url = `${API_URL}/api/v1/district/get-by-provinces`
    return axios.post(url, provinceCodes)
  },
}

export {districtApi}


